<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <p class="entity-page-title text-white fw-bold lh-sm mb-1">Users</p>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              View global users before assigning them to projects.
            </p>
          </div>
          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm align-self-end"
              data-bs-toggle="modal"
              data-bs-target="#create_user_modal"
              @click="open_create_user_modal"
            >
              <i class="bi bi-person-plus-fill me-2 text-white"></i>
              Create User
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Total Users
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ users.length }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-people-fill"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Active Users
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ active_users_count }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-person-check-fill"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Inactive Users
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ inactive_users_count }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-person-dash-fill"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div class="d-flex align-items-center gap-3 mb-3">
        <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
          <i class="bi bi-people-fill"></i>
        </div>
        <div class="entity-section-title fw-bold fs-6">Global Users</div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-4">User Name</div>
          <div class="col-lg-2">Phone Number</div>
          <div class="col-lg-2">Role</div>
          <div class="col-lg-4"></div>
        </div>
      </div>

      <div v-if="is_loading" class="d-flex align-items-center gap-2 text-secondary py-3">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>Loading users...</span>
      </div>

      <div v-else-if="users.length" class="d-flex flex-column gap-2">
        <article
          v-for="user in users"
          :key="user.id"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="row g-2 align-items-center">
            <div class="col-12 col-lg-4 d-flex align-items-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                <i class="bi bi-person-fill"></i>
              </div>
              <div>
                <div class="entity-name fw-bold">{{ user.name }}</div>
                <div class="entity-updated text-secondary small">{{ user.email }}</div>
              </div>
            </div>

            <div class="col-6 col-lg-2 text-secondary small">
              {{ user.phone_number || 'No phone number' }}
            </div>

            <div class="col-6 col-lg-2 text-secondary small">
              {{ user.role }}
            </div>

            <div class="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-center gap-2">
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                data-bs-toggle="modal"
                data-bs-target="#edit_user_modal"
                @click="open_edit_user_modal(user)"
              >
                Edit
              </button>
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                :data-bs-toggle="user.is_active === false ? null : 'modal'"
                :data-bs-target="user.is_active === false ? null : '#assign_user_modal'"
                @click="open_assign_user_modal(user)"
              >
                Assign
              </button>
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                @click="toggle_user_status(user)"
              >
                {{ user.is_active === false ? 'Activate' : 'Deactivate' }}
              </button>
            </div>
          </div>
        </article>
      </div>

      <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
        <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
          <i class="bi bi-people fs-3"></i>
        </div>
        <div class="fw-bold mb-1">No Users Found</div>
        <div class="text-secondary small">Global users will appear here once they exist.</div>
      </div>
    </section>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="create_user_modal"
      tabindex="-1"
      aria-labelledby="create_user_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs mb-0" id="create_user_modal_label">
              Create User
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="user_first_name" class="modal-form-label form-label text-xxs">
                First Name:
              </label>
              <input
                id="user_first_name"
                v-model="create_form.first_name"
                type="text"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter First Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_user_name_field('create_form', 'first_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="user_last_name" class="modal-form-label form-label text-xxs">
                Last Name:
              </label>
              <input
                id="user_last_name"
                v-model="create_form.last_name"
                type="text"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Last Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_user_name_field('create_form', 'last_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="user_email" class="modal-form-label form-label text-xxs">
                Email:
              </label>
              <input
                id="user_email"
                v-model="create_form.email"
                type="email"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Email Address Here"
                required
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="user_phone_number" class="modal-form-label form-label text-xxs">
                Phone Number:
              </label>
              <input
                id="user_phone_number"
                v-model="create_form.phone_number"
                type="tel"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Phone Number Here"
                minlength="10"
                maxlength="10"
                pattern="[0-9]{10}"
                required
                @input="sanitize_phone_field('create_form')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="user_role" class="modal-form-label form-label text-xxs">
                Role:
              </label>
              <select
                id="user_role"
                v-model="create_form.role"
                class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                :disabled="roles_loading"
                @change="handle_create_role_change"
              >
                <option value="" disabled hidden>
                  {{ roles_loading ? 'Loading Roles...' : 'Select Role' }}
                </option>
                <option
                  v-for="role in roles"
                  :key="role.id"
                  :value="role.role"
                >
                  {{ role.role }}
                </option>
              </select>
            </div>

            <div
              v-if="create_form.role && create_form.role.toLowerCase().includes('coordinator')"
              class="modal-form-group form-group mb-3"
            >
              <label for="user_domain" class="modal-form-label form-label text-xxs">
                Entity Type:
              </label>
              <select
                id="user_domain"
                v-model="create_form.entity_type_id"
                class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                :disabled="entity_types_loading"
              >
                <option value="" disabled hidden>
                  {{ entity_types_loading ? 'Loading Entity Types...' : 'Select Entity Type' }}
                </option>
                <option
                  v-for="entity_type in entity_type_options"
                  :key="entity_type.id"
                  :value="String(entity_type.id)"
                >
                  {{ entity_type.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
              :disabled="creating_user"
              @click="create_user"
            >
              <span
                v-if="creating_user"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="edit_user_modal"
      tabindex="-1"
      aria-labelledby="edit_user_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs mb-0" id="edit_user_modal_label">
              Edit User
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="edit_user_first_name" class="modal-form-label form-label text-xxs">
                First Name:
              </label>
              <input
                id="edit_user_first_name"
                v-model="edit_form.first_name"
                type="text"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter First Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_user_name_field('edit_form', 'first_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_user_last_name" class="modal-form-label form-label text-xxs">
                Last Name:
              </label>
              <input
                id="edit_user_last_name"
                v-model="edit_form.last_name"
                type="text"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Last Name Here"
                minlength="2"
                maxlength="50"
                required
                @input="sanitize_user_name_field('edit_form', 'last_name')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_user_email" class="modal-form-label form-label text-xxs">
                Email:
              </label>
              <input
                id="edit_user_email"
                v-model="edit_form.email"
                type="email"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Email Address Here"
                required
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_user_phone_number" class="modal-form-label form-label text-xxs">
                Phone Number:
              </label>
              <input
                id="edit_user_phone_number"
                v-model="edit_form.phone_number"
                type="tel"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Phone Number Here"
                minlength="10"
                maxlength="10"
                pattern="[0-9]{10}"
                required
                @input="sanitize_phone_field('edit_form')"
              >
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_user_role" class="modal-form-label form-label text-xxs">
                Role:
              </label>
              <select
                id="edit_user_role"
                v-model="edit_form.role_id"
                class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                :disabled="roles_loading"
                @change="handle_edit_role_change"
              >
                <option value="" disabled hidden>
                  {{ roles_loading ? 'Loading Roles...' : 'Select Role' }}
                </option>
                <option
                  v-for="role in roles"
                  :key="role.id"
                  :value="role.id"
                >
                  {{ role.role }}
                </option>
              </select>
            </div>

            <div
              v-if="roles.find((role) => String(role.id) === String(edit_form.role_id) && role.role && role.role.toLowerCase().includes('coordinator'))"
              class="modal-form-group form-group mb-3"
            >
              <label for="edit_user_domain" class="modal-form-label form-label text-xxs">
                Entity Type:
              </label>
              <select
                id="edit_user_domain"
                v-model="edit_form.entity_type_id"
                class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                :disabled="entity_types_loading"
              >
                <option value="" disabled hidden>
                  {{ entity_types_loading ? 'Loading Entity Types...' : 'Select Entity Type' }}
                </option>
                <option
                  v-if="should_show_selected_edit_entity_type_fallback() && get_selected_edit_entity_type_label()"
                  :value="String(edit_form.entity_type_id)"
                >
                  {{ get_selected_edit_entity_type_label() }}
                </option>
                <option
                  v-for="entity_type in entity_type_options"
                  :key="entity_type.id"
                  :value="String(entity_type.id)"
                >
                  {{ entity_type.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
              :disabled="updating_user"
              @click="update_user"
            >
              <span
                v-if="updating_user"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="assign_user_modal"
      tabindex="-1"
      aria-labelledby="assign_user_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg assign-user-modal-content">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs mb-0" id="assign_user_modal_label">
              Assign User <span v-if="assign_form.user?.name" class="fw-normal">- {{ assign_form.user.name }}</span>
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body assign-user-modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xxs">
                Projects:
              </label>
              <div class="dropdown w-100 assign-project-dropdown">
                <button
                  type="button"
                  class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm d-flex align-items-center justify-content-between bg-white"
                  :disabled="projects_loading || assigned_projects_loading"
                  @click="toggle_project_dropdown"
                >
                  <span class="text-truncate">{{ (projects_loading || assigned_projects_loading) ? 'Loading Projects...' : selected_project_name }}</span>
                  <i class="bi bi-chevron-down"></i>
                </button>

                <div
                  v-if="show_project_dropdown"
                  class="dropdown-menu show w-100 p-2 border-0 rounded-small shadow-sm assign-project-menu"
                >
                  <input
                    v-model="assign_form.project_search"
                    type="search"
                    class="form-control text-xxs rounded-small p-2 mb-2"
                    placeholder="Search project"
                  >
                  <div class="d-flex flex-column gap-1 project-dropdown-list">
                    <button
                      v-for="project in filtered_projects"
                      :key="project.id"
                      type="button"
                      class="dropdown-item rounded-small text-xxs assign-project-option d-flex align-items-center justify-content-between gap-2"
                      :class="{ 'is-selected': is_project_selected(project.id) }"
                      @click="select_project(project)"
                    >
                      <span class="text-truncate">{{ project_display_name(project) }}</span>
                      <i
                        v-if="is_project_selected(project.id)"
                        class="bi bi-check2 flex-shrink-0"
                        aria-hidden="true"
                      ></i>
                    </button>
                    <div
                      v-if="!filtered_projects.length"
                      class="text-secondary text-xxs px-2 py-2"
                    >
                      No projects match your search.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
              :disabled="assigning_user"
              @click="assign_user_to_project"
            >
              <span
                v-if="assigning_user"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Assign
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
